import { render, staticRenderFns } from "./AddBtn.vue?vue&type=template&id=66b703b1"
import script from "./AddBtn.vue?vue&type=script&lang=js"
export * from "./AddBtn.vue?vue&type=script&lang=js"
import style0 from "./AddBtn.vue?vue&type=style&index=0&id=66b703b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports